import * as React from "react";

import { ScrollBar } from "./HorizontalScroll.styles";

interface HorizontalScrollProps {
    onChangeScrollLeft: (nextScrollLeft: number) => void;
    scrollBarPosition: "Top" | "Fixed" | "Bottom";
    scrollBarSize: number; // Видимая Ширина
    scrollPos: number; // scrollLeft
    innerWidth: number; // Щириана контента
    visibility: boolean;
}

export class HorizontalScroll extends React.PureComponent<HorizontalScrollProps> {
    public static defaultProps = {
        scrollBarPosition: "Top",
        visibility: false,
        scrollPos: 0,
        scrollBarSize: 0,
    };

    private readonly scrollBar = React.createRef<HTMLDivElement>();
    private suspendNextScrollChange = false;
    private suspendNextPropsScrollChange = false;

    public UNSAFE_componentWillReceiveProps(nextProps: Readonly<HorizontalScrollProps>): void {
        if (this.scrollBar.current != undefined) {
            if (this.suspendNextPropsScrollChange) {
                this.suspendNextPropsScrollChange = false;
            } else {
                this.scrollBar.current.scrollLeft = nextProps.scrollPos;
                this.suspendNextScrollChange = true;
            }
        }
    }

    public render(): JSX.Element {
        if (this.props.visibility) {
            return (
                <ScrollBar
                    position={this.props.scrollBarPosition}
                    ref={this.scrollBar}
                    onScroll={x => {
                        if (this.suspendNextScrollChange) {
                            this.suspendNextScrollChange = false;
                        } else {
                            this.props.onChangeScrollLeft(x.currentTarget.scrollLeft);
                            this.suspendNextPropsScrollChange = true;
                        }
                    }}
                    style={{
                        width: this.props.scrollBarSize,
                    }}>
                    <div style={{ height: "1px", width: this.props.innerWidth }} />
                </ScrollBar>
            );
        }

        return <div />;
    }
}
